import { Component, HostListener } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ResetPasswordFields, ResetPasswordForm, generateResetPasswordForm } from '../../../../routes/auth/reset-password/form.functions';
import { DividerModule } from 'primeng/divider';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerComponent } from '../../../components/banner/banner.component';
import { InlineInputControlComponent } from '../../../components/form/inline-input-control/inline-input-control.component';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { DataService } from '../../../../core/providers/data/data.service';
import { ResetPasswordMutation, ResetPasswordMutationVariables } from '../../../../graphql/generated/generated-types';
import { RESET_PASSWORD } from '../../../../routes/auth/reset-password/reset-password.graphql';
import { StateService } from '../../../../core/state/old/state.service';

export interface ResetDialogData {
  token: string;
}

@Component({
  selector: 'app-reset-password-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    PasswordModule,
    DividerModule,
    BannerComponent,
    InlineInputControlComponent,
    RegisterDialogComponent,
  ],
  templateUrl: './reset-password-dialog.component.html',
  styleUrl: './../auth-dialog-pages.scss'
})
export class ResetPasswordDialogComponent {
  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.token && this.resetPasswordForm.valid && (this.resetPasswordForm.get(ResetPasswordFields.Password)?.value == this.resetPasswordForm.get(ResetPasswordFields.RepeatNewPassword)?.value)) {
      this.confirmPasswordReset();
    }
  }


  public token!: string | undefined;
  public loading = false;
  public submited = false;


  public resetPasswordForm: FormGroup<ResetPasswordForm> = generateResetPasswordForm();
  public ResetPasswordFields = ResetPasswordFields;

  constructor(
    private router: Router,
    private dialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private dataService: DataService,
    private stateService: StateService,
    private config: DynamicDialogConfig<ResetDialogData>
  ) {
    this.token = this.config.data?.token;

  }

  public confirmPasswordReset() {
    if (this.token) {
      this.dataService.mutate<ResetPasswordMutation, ResetPasswordMutationVariables>(RESET_PASSWORD, {
        token: this.token,
        password: this.resetPasswordForm.get(ResetPasswordFields.Password)?.value!,
      }).pipe(take(1))
        .subscribe(
          () => {
            this.stateService.setState('signedIn', true);
            this.router.navigate(['/user/account']);
            this.closeDialog();
          },
        );
    }
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public openRegisterDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(RegisterDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }


}
